import type { CityKey } from "@/domain/ramadan";

export interface CityConfig {
  name: string;
  province: string;
  seoTitle: string;
  seoDescription: string;
  introText: string;
  citySection: string;
  faq: {
    question: string;
    answer: string;
  };
}

export const cities: Record<CityKey, CityConfig> = {
  karachi: {
    name: "Karachi",
    province: "Sindh",
    seoTitle: "Karachi Sehri Iftar Time Today - 2026 Ramadan Calendar",
    seoDescription:
      "Karachi Ramadan calendar 2026 ke mutabiq sehri aur iftar ke exact auqat. Aaj ka roza timing aur poora Ramzan schedule dekhein.",
    introText:
      "Karachi Ramadan 2026 (Ramzan) ke liye aaj ka Sehri aur Iftar time yahan live update hota hai. Poora 30 din ka Ramadan calendar neeche dekhein.",
    citySection: `
Karachi Pakistan ka sab se bara shehar hai aur yahan Ramadan ka mahaul bohat pur-josh hota hai.
Samundari shehar hone ki wajah se yahan ke sehri aur iftar ke auqat dusre shehron se thore mukhtalif ho sakte hain.
Karachi Ramadan calendar 2026 ke mutabiq aaj ka exact roza timing upar diya gaya hai.
`,
    faq: {
      question: "Sehri time Karachi today kitne baje hai?",
      answer:
        "Aaj ka Sehri time Karachi ke liye upar live update ke sath diya gaya hai jo rozana refresh hota hai.",
    },
  },
  lahore: {
    name: "Lahore",
    province: "Punjab",
    seoTitle: "Sehri & Iftar Time Lahore 2026 - Ramzan Calendar Today",
    seoDescription:
      "Lahore Ramadan calendar 2026 aur aaj ka sehri time Lahore. Iftar time Lahore 2026 ke exact auqat dekhein.",
    introText:
      "Lahore Ramadan 2026 (Ramzan) ke liye aaj ka Sehri aur Iftar time yahan live update hota hai. Poora 30 din ka Ramadan calendar neeche dekhein.",
    citySection: `
Punjab ka markazi aur cultural shehar Lahore Ramadan ke dauran roshniyon aur masajid ke mahaul se mashhoor hai.
Lahore Ramadan calendar 2026 ke mutabiq yahan ke sehri aur iftar ke auqat central Punjab ke hisaab se hote hain.
Iftar time Lahore 2026 aur aaj ka roza timing upar diya gaya hai.
`,
    faq: {
      question: "Lahore Ramadan calendar 2026 kahan dekhein?",
      answer:
        "Lahore Ramadan calendar 2026 ka poora schedule aur aaj ka Sehri time Lahore yahin available hai.",
    },
  },
  islamabad: {
    name: "Islamabad",
    province: "Federal Capital",
    seoTitle: "Islamabad Sehri & Iftar Time Today – Ramadan 2026 Roza Timings",
    seoDescription:
      "Islamabad mein aaj ka Sehri time aur Iftar time dekhein. Ramadan 2026 ke liye Islamabad Sehri & Iftar timings daily update hoti hain. Poora Ramadan calendar bhi yahan available hai.",
    introText:
      "Islamabad Ramadan 2026 (Ramzan) ke liye aaj ka Sehri aur Iftar time yahan live update hota hai. Poora 30 din ka Ramadan calendar neeche dekhein.",
    citySection: `
Pakistan ka dar-ul-hukumat Islamabad pahadon ke darmiyan waqay hai aur yahan Ramadan ka sukoon bhara mahaul hota hai.
Islamabad Ramadan calendar 2026 ke hisaab se yahan ke sehri aur iftar ke auqat northern areas ke qareeb hain.
Faisal Masjid aur dusri masajid mein iftar ka intizam khas tor par mashoor hai.
`,
    faq: {
      question: "Islamabad mein sehri time kya hai?",
      answer:
        "Islamabad mein aaj ka sehri time aur iftar time upar diya gaya hai jo daily update hota hai.",
    },
  },
  multan: {
    name: "Multan",
    province: "Punjab",
    seoTitle: "Multan Sehri Iftar Timing Today – Multan Ramzan Calendar 2026",
    seoDescription:
      "Multan ka aaj ka Sehri Iftar time aur poora Ramadan Calendar 2026 — Multan ke 30 dinon ke roza auqat accurate timing ke saath yahan dekhein.",
    introText:
      "Multan Ramadan 2026 (Ramzan) ke liye aaj ka Sehri aur Iftar time yahan live update hota hai. Poora 30 din ka Ramadan calendar neeche dekhein.",
    citySection: `
Madinat-ul-Auliya ke naam se mashhoor Multan auliya aur sufiya ke shehar ke tor par janna jata hai.
Multan Ramadan calendar 2026 ke mutabiq yahan ke sehri aur iftar ke auqat southern Punjab ke climate ke hisaab se hote hain.
Shrines aur khanqahon mein iftar aur taraweeh ka khas rohani mahaul banta hai.
`,
    faq: {
      question: "Multan Ramadan timing 2026 kya hai?",
      answer:
        "Multan Ramadan timing 2026 ka mukammal calendar aur aaj ka sehri iftar time is page par available hai.",
    },
  },
  quetta: {
    name: "Quetta",
    province: "Balochistan",
    seoTitle: "Sehri & Iftar Time Quetta 2026 - Ramadan Calendar Today",
    seoDescription:
      "Quetta Ramadan calendar 2026 ke mutabiq sehri aur iftar ke exact auqat. Balochistan ke markaz mein aaj ka roza timing dekhein.",
    introText:
      "Quetta Ramadan 2026 (Ramzan) ke liye aaj ka Sehri aur Iftar time yahan live update hota hai. Poora 30 din ka Ramadan calendar neeche dekhein.",
    citySection: `
Balochistan ka markazi shehar Quetta buland pahadon ke darmiyan waqay hai aur yahan ka mosam saaf aur thanda hota hai.
Quetta Ramadan calendar 2026 ke hisaab se yahan ke sehri aur iftar ke auqat altitude ki wajah se thora mukhtalif hote hain.
Quetta mein Ramadan ka mahaul saada magar bohat mutbarrik hota hai.
`,
    faq: {
      question: "Quetta mein iftar kitne baje hota hai?",
      answer:
        "Quetta mein aaj ka iftar time aur sehri time upar live diya gaya hai jo har roz update hota hai.",
    },
  },
  gilgit: {
    name: "Gilgit",
    province: "Gilgit-Baltistan",
    seoTitle: "Sehri & Iftar Time Gilgit 2026 - Ramadan Calendar Today",
    seoDescription:
      "Gilgit Ramadan calendar 2026 ke mutabiq sehri aur iftar ke exact auqat. Northern areas mein aaj ka roza timing dekhein.",
    introText:
      "Gilgit Ramadan 2026 (Ramzan) ke liye aaj ka Sehri aur Iftar time yahan live update hota hai. Poora 30 din ka Ramadan calendar neeche dekhein.",
    citySection: `
Gilgit-Baltistan ke northern ilaaqay mein waqay Gilgit buland pahadon aur khubsurat wadion ke darmiyan hai.
Gilgit Ramadan calendar 2026 ke mutabiq yahan ke sehri aur iftar ke auqat Pakistan ke baqi shehron se kaafi mukhtalif hote hain.
Bulandion ki wajah se suraj jaldi tulou aur der se ghuroob hota hai, is liye roza ka waqt zyada lamba hota hai.
`,
    faq: {
      question: "Gilgit mein roza kitne ghante ka hota hai?",
      answer:
        "Gilgit mein roza ka duration northern location ki wajah se dusre shehron se zyada hota hai. Exact timing upar dekhein.",
    },
  },
};

export const cityKeys = Object.keys(cities) as CityKey[];
